import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// Tus páginas
import Login from './Pages/Login/login';
import Departamento from './Pages/Departamentos/departamentos';
import Proveedores from './Pages/Proveedores/proveedores';
import Usuarios from './Pages/Usuarios/usuarios';
import Lineas from './Pages/Lineas/lineas';
import Sublineas from './Pages/Sublineas/sublineas';
import Marcas from './Pages/Marcas/marcas';
import Prueba from './Pages/Prueba/prueba';
import Unidades from './Pages/Unidades/unidades';
import Sucursales from './Pages/Sucursales/sucursales';
import Salidas from './Pages/salidas/salidas';
import Productos from './Pages/Productos/productos';
import Entradas from './Pages/Entradas/entradas';
import Inventario from './Pages/Inventario/inventario';
import Consultor from './Pages/Consultor/consultor';
import QR from './Pages/qr/QR';
import RPeticiones from './Pages/Rpeticiones/rpeticiones';

// NUEVO
import RustdeskPage from './Pages/RustDesk/RustdeskPage';
import Rust from './Pages/Rust/Rust';

import PrivateRoute from './Services/PrivateRoute';
import PrivateRouteEmpleados from './Services/PrivateRouteEmpleados';

import Inicio from './Pages/Inicio/inicio';
import Saldos from './Pages/Saldos/saldos';
import InvSaldos from './Pages/invitados/invsaldos';
import Invinventario from './Pages/invitados/invinventario';
import Invconsultor from './Pages/invitados/invconsultor';
import Invinicio from './Pages/Inicio/invinicio';
import Mantenimiento from './Pages/Mantenimiento/mantenimiento';
import Traspasos from './Pages/Traspasos/traspasos';
import Empleados from './Pages/Login Empleados/loginempleados';
import Peticiones from './Pages/Peticiones/peticiones';
import PeticionesAdmin from './Pages/PeticionesAdmin/peticionesadmin';
import EmpleadosPass from './Pages/Empleados/empleados';
import EmpleadosAdmin from './Pages/empleadosAdmin/empleadosAdmin';
import Empinicio from './Pages/Empinicio/empinicio';
import Recientes from './Pages/Recientes/recientes';
import Totales from './Pages/Totales/totales';
import PeticionesPanel from './Pages/peticionesPanel/PeticionesPanel';
import Facturas from './Pages/facturas/facturas';
import Clicencias from './Pages/CLicencias/clicencias';
import Licencias from './Pages/licencias/licencias';
import Server from './Pages/Server/server';
import Bitacora from './Pages/Bitacora/bitacora';

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Públicas */}
        <Route path="/login" element={<Login />} />
        <Route index element={<Login />} />
        <Route path="/invinicio" element={<Invinicio />} />
        <Route path="/invsaldos" element={<InvSaldos />} />
        <Route path="/invinventario" element={<Invinventario />} />
        <Route path="/invconsultor" element={<Invconsultor />} />
        <Route path="/loginempleados" element={<Empleados />} />
        <Route path="/QR" element={<QR />} />
        <Route path="/PP" element={<PeticionesPanel />} />

        {/* PROTEGIDAS ADMIN */}
        <Route element={<PrivateRoute />}>

          <Route path="/inicio" element={<Inicio />} />
          <Route path="/Rust" element={<Rust />} />

          <Route path="/sucursales" element={<Sucursales />} />
          <Route path="/departamentos" element={<Departamento />} />
          <Route path="/proveedores" element={<Proveedores />} />
          <Route path="/peticionesadmin" element={<PeticionesAdmin />} />
          <Route path="/usuarios" element={<Usuarios />} />
          <Route path="/lineas" element={<Lineas />} />
          <Route path="/sublineas" element={<Sublineas />} />
          <Route path="/marcas" element={<Marcas />} />
          <Route path="/unidades" element={<Unidades />} />
          <Route path="/prueba" element={<Prueba />} />
          <Route path="/salida" element={<Salidas />} />
          <Route path="/mantenimiento" element={<Mantenimiento />} />
          <Route path="/producto" element={<Productos />} />
          <Route path="/entrada" element={<Entradas />} />
          <Route path="/inventario" element={<Inventario />} />
          <Route path="/saldos" element={<Saldos />} />
          <Route path="/consultor" element={<Consultor />} />
          <Route path="/traspasos" element={<Traspasos />} />
          <Route path="/empleadosAdmin" element={<EmpleadosAdmin />} />
          <Route path="/recientes" element={<Recientes />} />
          <Route path="/totales" element={<Totales />} />
          <Route path="/referencias" element={<Facturas />} />
          <Route path="/reporte-peticiones" element={<RPeticiones />} />
          <Route path="/clicencias" element={<Clicencias />} />
          <Route path="/licencias" element={<Licencias />} />
          <Route path="/server" element={<Server />} />
          <Route path="/bitacora" element={<Bitacora />} />

          {/* NUEVA RUTA RUSTDESK */}
          <Route path="/rustdesk" element={<RustdeskPage />} />

        </Route>

        {/* PROTEGIDAS EMPLEADOS */}
        <Route element={<PrivateRouteEmpleados />}>
          <Route path="/empinicio" element={<Empinicio />} />
          <Route path="/peticiones" element={<Peticiones />} />
          <Route path="/empleados" element={<EmpleadosPass />} />
        </Route>

        {/* Default */}
        <Route path="*" element={<Navigate to="/login" replace />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;